import { danish } from './da-DK';
import { britishEnglish } from './en-GB';

export const defaultTranslations = {
  'da-DK': danish,
  'en-GB': britishEnglish,
};
